class DiscountBadgeProduct extends HTMLElement {
  constructor() {
    super();

    // console.log('DiscountBadgeProduct init');

    messenger.listen(
      messenger.topics.VARIANT_CHANGE,
      /**
       * @param {Variant} variant
       **/
      (variant) => {
        // console.log('received variant change: ', variant);
        this.onVariantChange(variant);
      },
      'DiscountBadgeProduct'
    );

    this.showSpecialOffer = this.dataset.specialOffer === 'true' ? true : false;

    this.percentageSymbol = {
      show: () => {
        /**
         * @type {HTMLElement | null}
         **/
        const el = this.querySelector('.discount-badge__symbol');
        if (!el) {
          console.log("failed to find percentage symbol");
          return;
        }
        el.style.display = 'block';
      },
      hide: () => {
        /**
         * @type {HTMLElement | null}
         **/
        const el = this.querySelector('.discount-badge__symbol');
        if (!el) {
          console.log("failed to find percentage symbol");
          return;
        }
        el.style.display = 'none';
      },
    };
  }

  /**
   * @param {Variant} variant
   **/
  onVariantChange(variant) {
    const discount = knocking.calculateDiscountPercent(variant);
    this.updateDiscountBadge(discount);
  }

  /**
   * @param {number | string} discount
   */
  updateDiscountBadge(discount) {
    /**
     * @type {HTMLElement | null}
     */
    const badgeText = this.querySelector(".discount-badge__text");
    /**
     * @type {HTMLElement | null}
     */
    const badge = this.querySelector(".discount-badge");
    if (!badge || !badgeText) {
      console.log("failed to find badge elements...");
      return;
    }

    if (discount === 'Exclusive Offer') {
      badgeText.textContent = `${discount}`;
      this.percentageSymbol.hide();
      badge.classList.remove('special');
      badge.classList.add('exclusive');
      badgeText.classList.remove('special');
      badgeText.classList.add('exclusive');
    } else if (typeof discount === "number" && discount <= 20 && this.showSpecialOffer) {
      badgeText.textContent = `Special Offer`;
      this.percentageSymbol.hide();
      badge.classList.remove('exclusive');
      badge.classList.add('special');
      badgeText.classList.remove('exclusive');
      badgeText.classList.add('special');
    } else {
      badgeText.textContent = `${discount}`;
      this.percentageSymbol.show();
      badge.classList.remove(
        'exclusive',
        'special'
      );
      badgeText.classList.remove(
        'exclusive',
        'special'
      );
    }
  }
}

customElements.define('discount-badge-product', DiscountBadgeProduct);
